import * as tslib_1 from "tslib";
import { CollectionField } from './collection_field';
var ViewField = /** @class */ (function (_super) {
    tslib_1.__extends(ViewField, _super);
    function ViewField(param) {
        return _super.call(this, param) || this;
    }
    ViewField.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "ViewField" });
    };
    ViewField.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return ViewField;
}(CollectionField));
export { ViewField };
//# sourceMappingURL=view_field.js.map